import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "../utils/publicAnalytics";
import { signupLayoutName } from "../utils/signupGoogleFirstFlag";

export default function AnalyticsRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/signup") {
      trackPageView(location.pathname, { signup_layout: signupLayoutName() });
      return;
    }
    trackPageView(location.pathname);
  }, [location.pathname, location.search]);

  return null;
}
